import gql from 'graphql-tag'

const updateDelegation = (delegationId, delegation) => ({
	mutation: gql`
		mutation (
			$delegationId: bigint!
			$delegation: organizations_delegations_set_input!
		) {
			update_organizations_delegations_by_pk(
				pk_columns: { id: $delegationId }
				_set: $delegation
			) {
				id
			}
		}
	`,
	variables: { delegationId, delegation }
})

export { updateDelegation }
